export class AppConfig {

  static developmentURL: string = 'https://gzhapi.goodyiyao.com/api';

  static productionURL: string = 'https://gzhapi.goodyiyao.com/api';

  static routeMode: 'hash' | 'history' = 'hash';
}
